import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { SchoolTwoColumnLayoutComponent } from 'Src/ng2/school/layouts/school-two-column-layout/school-two-column-layout.component';
import { IPageBannerMeta } from '../../page-banner/page-banner.interface';
import { SettingsleftNavService } from '../settings-left-nav/settings-left-nav-service';
import { take, tap, Unsubscribable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getSchool } from 'Src/ng2/store/selectors/school-selectors';
import { IUrlNavigateOpts, PrevStateService } from 'Src/ng2/shared/services/prev-state/prev-state.service';
import { UrlPathService } from 'Src/ng2/shared/services/url-path-service/url-path.service';
import { INotesFlyoutPanelServiceOpts, NotesFlyoutPanelService } from 'Src/ng2/shared/flyouts/notes/notes-flyout-panel.service';
import { NOTE_FLYOUT_MODES } from 'Src/ng2/shared/typings/interfaces/notes_v2.interface';
import { PartnerTypes } from 'Src/ng2/shared/typings/interfaces/partner.interface';
import { ISchool } from 'Src/ng2/shared/typings/interfaces/school.interface';

@Component({
  templateUrl: './settings-layout.component.html',
  selector: 'settings-layout',
  styleUrls: ['./settings-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})

export class SettingsLayoutComponent extends SchoolTwoColumnLayoutComponent implements OnInit, OnDestroy {
  public pageBannerMeta: IPageBannerMeta = {};

  public infoHoverTooltip = 'This section allows you to create and modify user accounts at your school.';

  public selectedLeftNavItem: { name: string; tooltip: string; };
  public hasLoaded = false;
  public exitState: IUrlNavigateOpts;

  public school: ISchool;
  public contextPartnerId: string;

  private navSub: Unsubscribable;

  constructor (
    private settingsLeftNavService: SettingsleftNavService,
    private prevStateService: PrevStateService,
    private urlPathService: UrlPathService,
    private store: Store,
    private notesFlyoutPanelService: NotesFlyoutPanelService,
  ) {
    super();
  }

  ngOnInit (): void {
    this.store.select(getSchool).pipe(
      take(1),
      tap(currentSchool => {
        this.school = currentSchool;
        this.contextPartnerId = this.school._id;
        const homepageUrl = this.urlPathService.computeDistrictUrlPath(`/school/${currentSchool._id}/home`);
        this.exitState = this.prevStateService.getPrevUrlNavigateOpts({ designatedPrevUrls: [homepageUrl], fallbackUrl: homepageUrl });
      })).subscribe();

    this.navSub = this.settingsLeftNavService.getSelectedItem$().pipe(
      tap(item => {
        this.selectedLeftNavItem = item;
        this.hasLoaded = true;
      }),
    ).subscribe();
  }

  ngOnDestroy (): void {
    this.navSub.unsubscribe();
  }

  handleAddNote (): void {
    const opts: INotesFlyoutPanelServiceOpts = {
      mode: NOTE_FLYOUT_MODES.CREATE,
      contextPartnerId: this.contextPartnerId,
      contextPartnerType: PartnerTypes.SCHOOL,
      school: this.school,
    };
    this.notesFlyoutPanelService.openNoteFlyout(opts);
  }
}
